import React, { useRef, useEffect } from 'react';
import parseHtml from 'html-react-parser';

const SatButton = props => {
  const {
    label,
    styleClass,
    disabled,
    onClick,
    iconStyleClass,
    onValidNotiModal,
    isNoSpan = false,
    moveFocus,
  } = props;

  const btnRef = useRef();

  useEffect(() => {
    if (moveFocus) {
      btnRef.current.focus();
    }
  }, [moveFocus]);

  return (
    <button
      ref={btnRef}
      className={`${styleClass} ${disabled ? 'disabled' : ''}`}
      onClick={() => {
        if (disabled) {
          if (onValidNotiModal && typeof onValidNotiModal === 'function') {
            onValidNotiModal();
          }
        } else {
          onClick();
        }
      }}
    >
      {iconStyleClass ? (
        <>
          <span className={iconStyleClass} />
          {label ? parseHtml(label) : ''}
        </>
      ) : isNoSpan ? (
        (label || '').split('\n').map(text => {
          return (
            <>
              {text}
              <br />
            </>
          );
        })
      ) : (
        <span>{label ? parseHtml(label) : ''}</span>
      )}
    </button>
  );
};

export default SatButton;
